<template>
    <div class="module module-info">
        <h1 class="title--m mb-2">5 DATOS DEL CLIENTE</h1>
        <h3 class="title--xs mt-2 title-line">datos indicados por el cliente</h3>
        <p class="text--smaller">Nombre: {{this.$bus.pConsulta.datosOrden.DATOSCLIENTE.NOMBRE}}</p>
        <p class="text--smaller">DNI/CIF: {{this.$bus.pConsulta.datosOrden.DATOSCLIENTE.DNI}}</p>
        <p class="text--smaller">Telefono: {{this.$bus.pConsulta.datosOrden.DATOSCLIENTE.TELEFONO | telefono}}</p>
        <p class="text--smaller">Mail: {{this.$bus.pConsulta.datosOrden.DATOSCLIENTE.MAIL | mail}}</p>
        <p class="text--smaller">Direccion: {{this.$bus.pConsulta.datosOrden.DATOSCLIENTE.DIRECCION}}</p>
        <p class="text--smaller">Codigo Postal: {{this.$bus.pConsulta.datosOrden.DATOSCLIENTE.CP}}</p>
        <p class="text--smaller">Poblacion: {{this.$bus.pConsulta.datosOrden.DATOSCLIENTE.POBLACION}}</p>
        <p class="text--smaller">Provincia: {{this.$bus.pConsulta.datosOrden.DATOSCLIENTE.PROVINCIA}}</p>
    </div>
</template>

<script>
    export default {
        filters: {
            mail: function (val) {
                if (val == '' || val == null || val == 0 || val == undefined) return 'Ninguno'
                else return val
            },
            telefono: function (val) {
                if (val == '' || val == null || val == 0 || val == undefined) return 'Ninguno'
                else return val
            },
        },
    }
</script>
<style lang="scss">
    .green-alert {
        color: #9be51a !important;
        background-color: white !important;
    }
</style>